/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowflyertagline3Inputs */

const en_organizerfollowflyertagline3 = /** @type {(inputs: Organizerfollowflyertagline3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow and tap the bell: then you get a message as soon as there is a new event.`)
};

const de_organizerfollowflyertagline3 = /** @type {(inputs: Organizerfollowflyertagline3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgen und die Glocke antippen: Dann bekommst du eine Nachricht, sobald es ein neues Event gibt.`)
};

/**
* | output |
* | --- |
* | "Follow and tap the bell: then you get a message as soon as there is a new event." |
*
* @param {Organizerfollowflyertagline3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowflyertagline3 = /** @type {((inputs?: Organizerfollowflyertagline3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowflyertagline3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowflyertagline3(inputs)
	return de_organizerfollowflyertagline3(inputs)
});
export { organizerfollowflyertagline3 as "organizerFollowFlyerTagline" }